export default "__VITE_ASSET__ffa1d988__"